<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Scroll" class="d-icon d-icon--scroll" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M.94 1.44A1.5 1.5 0 0 1 2 1h6.5A1.5 1.5 0 0 1 10 2.5V8h1a.5.5 0 0 1 .5.5v1A1.5 1.5 0 0 1 10 11H4a1.5 1.5 0 0 1-1.5-1.5v-5H1A.5.5 0 0 1 .5 4V2.5c0-.398.158-.78.44-1.06ZM3.5 9.5v-7a1.5 1.5 0 0 0-.086-.5H8.5a.5.5 0 0 1 .5.5V8H5a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0Zm-1-7v1h-1v-1a.5.5 0 1 1 1 0Zm7.854 7.354A.5.5 0 0 1 10 10H5.414a1.5 1.5 0 0 0 .086-.5V9h5v.5a.5.5 0 0 1-.146.354Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconScroll',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
